import {handleResponse, authHeader} from '../helpers';
const BASE_URL = process.env.REACT_APP_API_URL;
export const pizzaDeliveryService = {
	getPipelinesAndStages,
	getActiveConfigs,
	saveConfig,
	addNewConfig,
	deleteConfig,
}

function getPipelinesAndStages() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/pizza/pipeline-stages`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getActiveConfigs() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/pizza/configs`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function saveConfig(config) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(config)
	};

	return fetch(BASE_URL + `/pizza/config`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function addNewConfig(config) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/pizza/createConfig`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function deleteConfig(config) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(config)
	};

	return fetch(BASE_URL + `/pizza/deleteConfig`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}
